export default __webpack_public_path__ + "static/media/circle-up-arrow.88b2f26b.svg";